import { render, staticRenderFns } from "./accountgroup.vue?vue&type=template&id=00ced53c&scoped=true&"
import script from "./accountgroup.vue?vue&type=script&lang=js&"
export * from "./accountgroup.vue?vue&type=script&lang=js&"
import style0 from "./accountgroup.vue?vue&type=style&index=0&id=00ced53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ced53c",
  null
  
)

export default component.exports